var _a, _b;
import { __decorate, __metadata } from "tslib";
import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
class totalizerModel {
    constructor() {
        this.name = null;
        this.value = null;
        this.color = null;
        this.icon = null;
    }
}
let TotalizerModule = class TotalizerModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.totalizers = {};
    }
    get getTotalizer() {
        return this.totalizers;
    }
    get totalizer() {
        return this.totalizers.totalizer;
    }
    [_a = Mutations.SET_TOTALIZER_MUTATION](payload) {
        this.totalizers = payload;
    }
    [_b = Actions.SET_TOTALIZERS_ACTION](payload) {
        this.context.commit(Mutations.SET_TOTALIZER_MUTATION, payload);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TotalizerModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TotalizerModule.prototype, _b, null);
TotalizerModule = __decorate([
    Module
], TotalizerModule);
export default TotalizerModule;
//# sourceMappingURL=TotalizerModule.js.map